module.exports = __webpack_public_path__ + "img/noData.dae00d8c.png";